import { toast } from 'react-toastify';
import { API } from '../../utils/amplifyWrapper';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { voiceBookmarkKey } from '../../utils/voiceBookmark';

interface IToggleVoiceBookmarkProps {
    org_id: string
    voice: Record<string, any>
}

export const useToggleVoiceBookmark = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async ({ org_id, voice }: IToggleVoiceBookmarkProps) => {
            const response = await API.post(
                'main',
                `/organisation/${org_id}/voice/bookmark`,
                { headers: { "Content-Type": "application/json" }, body: { voice } }
            );
            return { response, org_id };
        },
        {
            
            onMutate: async ({ org_id, voice }: IToggleVoiceBookmarkProps) => {
                await queryClient.cancelQueries(['organisation', org_id]);
                const previousOrganisation = queryClient.getQueryData(['organisation', org_id]);
                const key = voiceBookmarkKey(voice);

                queryClient.setQueryData(['organisation', org_id], (old: any) => {
                    const bookmarked_voices = { ...(old?.bookmarked_voices || {}) };
                    if (bookmarked_voices[key]) {
                        delete bookmarked_voices[key];
                    } else {
                        bookmarked_voices[key] = voice;
                    }
                    return { ...old, bookmarked_voices };
                });

                return { previousOrganisation, org_id };
            },
            onError: (_err, _variables, context) => {
                if (context?.previousOrganisation) {
                    queryClient.setQueryData(['organisation', context.org_id], context.previousOrganisation);
                }
                toast.error("Something went wrong while updating your bookmark");
            },
            onSettled: (_data, _err, { org_id }) => {
                queryClient.invalidateQueries(['organisation', org_id]);
            },
        }
    )
}
